module.exports = __webpack_public_path__ + "img/nc_logo.a0bc6e67.png";